import { PlacementId, formatCurrency } from "@sp-crm/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { useGetClientQuery } from "../../../../generated/graphql";

interface Props {
    clientId: PlacementId;
}

export const InvoiceSummary: React.FC<Props> = props => {
    const queryKey = { id: props.clientId };
    const router = useHistory();

    const navigate = React.useCallback(() => {
        router.push(`/clients/show/${props.clientId}/invoices`);
    }, [router, props.clientId]);
    const query = useGetClientQuery(queryKey);
    if (
        query.data?.getClient?.invoices?.length !== 0 ||
        query.data?.getClient?.totalInvoiceAmountCents !== 0
    ) {
        const invoiceCount = (query.data?.getClient?.invoices || []).filter(
            i => i.status !== "void",
        ).length;

        const invoiceDisplay = (
            <>
                {formatCurrency(
                    (query.data?.getClient?.totalInvoiceAmountCents ?? 0) / 100,
                )}
                {invoiceCount > 1 ? (
                    <>
                        &nbsp;
                        <span>({invoiceCount} invoices)</span>
                    </>
                ) : null}
            </>
        );

        return (
            <div onClick={navigate}>
                <button
                    type="button"
                    className="rounded-full bg-blue-50 px-3 py-1 flex items-center gap-2 shadow border border-zinc-200 text-sm font-medium text-zinc-800 hover:bg-blue-100 transition"
                    aria-label="Invoice">
                    <div className="text-xs text-zinc-500">Invoice</div>
                    <div className="font-semibold">{invoiceDisplay}</div>
                </button>
            </div>
        );
    }
    return null;
};
